/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTimerecorddetailDto } from '../models/work-create-timerecorddetail-dto';
import { WorkDeleteTimerecorddetailDto } from '../models/work-delete-timerecorddetail-dto';
import { WorkHasTimerecorddetailsByUserIdAndDateDto } from '../models/work-has-timerecorddetails-by-user-id-and-date-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkReapplyPauseTemplateResultDto } from '../models/work-reapply-pause-template-result-dto';
import { WorkTimerecorddetail } from '../models/work-timerecorddetail';
import { WorkTimerecorddetailsByDateDto } from '../models/work-timerecorddetails-by-date-dto';
import { WorkTimerecorddetailsByTimerecordtypeDto } from '../models/work-timerecorddetails-by-timerecordtype-dto';
import { WorkUpdateTimerecorddetailDto } from '../models/work-update-timerecorddetail-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimerecorddetailsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange()` */
  static readonly TimerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRangePath = '/v2/timerecorddetails/byUserId/{userId}/hasEntries';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange$Response(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkHasTimerecorddetailsByUserIdAndDateDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRangePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.query('dateFrom', params.dateFrom, {});
      rb.query('dateTo', params.dateTo, {});
      rb.query('withDetails', params.withDetails, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkHasTimerecorddetailsByUserIdAndDateDto>>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkHasTimerecorddetailsByUserIdAndDateDto>> {
    return this.timerecorddetailsV2ControllerHasTimerecorddetailsByUserIdAndDateRange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkHasTimerecorddetailsByUserIdAndDateDto>>): Array<WorkHasTimerecorddetailsByUserIdAndDateDto> => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate()` */
  static readonly TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDatePath = '/v2/timerecorddetails/byUserId/{userId}/{date}';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate$Response(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetailsByDateDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDatePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetailsByDateDto>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetailsByDateDto> {
    return this.timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetailsByDateDto>): WorkTimerecorddetailsByDateDto => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth()` */
  static readonly TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonthPath = '/v2/timerecorddetails/byUserIdYearAndMonth/{userId}/{year}/{month}';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth$Response(
    params: {
      userId: number;
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonthPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth(
    params: {
      userId: number;
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecorddetailsByDateDto>> {
    return this.timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdYearAndMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>): Array<WorkTimerecorddetailsByDateDto> => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange()` */
  static readonly TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterangePath = '/v2/timerecorddetails/byUserIdAndDaterange/{userId}/{dateFrom}/{dateTo}';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange$Response(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterangePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecorddetailsByDateDto>> {
    return this.timerecorddetailsV2ControllerFindTimerecorddetailsByUserIdAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>): Array<WorkTimerecorddetailsByDateDto> => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindTimerecorddetailsPaginated()` */
  static readonly TimerecorddetailsV2ControllerFindTimerecorddetailsPaginatedPath = '/v2/timerecorddetails';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindTimerecorddetailsPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by timerecord.user.businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.timerecord.user.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.timerecord.user.businessdivisionId=$not:$like:John Doe&filter.timerecord.user.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.timerecord.user.businessdivisionId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> timerecord.workdate:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>timerecord.workdate</li>
     * <li>timerecord.user.lastName</li>
     * <li>hours</li></ul>
     */
      sortBy?: Array<'timerecord.workdate:ASC' | 'timerecord.workdate:DESC' | 'timerecord.user.lastName:ASC' | 'timerecord.user.lastName:DESC' | 'hours:ASC' | 'hours:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecorddetail>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
'timerecord.user.businessdivisionId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindTimerecorddetailsPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('filter.timerecord.user.businessdivisionId', params['filter.timerecord.user.businessdivisionId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTimerecorddetail>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'projectId'?: (string | Array<string>);
        'timerecord.user.businessdivisionId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindTimerecorddetailsPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by timerecord.user.businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.timerecord.user.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.timerecord.user.businessdivisionId=$not:$like:John Doe&filter.timerecord.user.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.timerecord.user.businessdivisionId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> timerecord.workdate:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>timerecord.workdate</li>
     * <li>timerecord.user.lastName</li>
     * <li>hours</li></ul>
     */
      sortBy?: Array<'timerecord.workdate:ASC' | 'timerecord.workdate:DESC' | 'timerecord.user.lastName:ASC' | 'timerecord.user.lastName:DESC' | 'hours:ASC' | 'hours:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecorddetail>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
'timerecord.user.businessdivisionId'?: (string | Array<string>);
};
};
}> {
    return this.timerecorddetailsV2ControllerFindTimerecorddetailsPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecorddetail>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
'timerecord.user.businessdivisionId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecorddetail>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
'timerecord.user.businessdivisionId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerCreate()` */
  static readonly TimerecorddetailsV2ControllerCreatePath = '/v2/timerecorddetails';

  /**
   * Required permissions: timerecorddetails:create, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerCreate$Response(
    params: {
      body: WorkCreateTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetail>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetail>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:create, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerCreate(
    params: {
      body: WorkCreateTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetail> {
    return this.timerecorddetailsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetail>): WorkTimerecorddetail => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser()` */
  static readonly TimerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUserPath = '/v2/timerecorddetails/byTimerecordtypeYearAndUser/{timerecordtypeId}/{year}/{userId}';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser$Response(
    params: {
      timerecordtypeId: number;
      year: number;
      userId: number;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetailsByTimerecordtypeDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUserPath, 'get');
    if (params) {
      rb.path('timerecordtypeId', params.timerecordtypeId, {});
      rb.path('year', params.year, {});
      rb.path('userId', params.userId, {});
      rb.query('withDetails', params.withDetails, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetailsByTimerecordtypeDto>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser(
    params: {
      timerecordtypeId: number;
      year: number;
      userId: number;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetailsByTimerecordtypeDto> {
    return this.timerecorddetailsV2ControllerFindTimerecorddetailsByTimerecordtypeYearAndUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetailsByTimerecordtypeDto>): WorkTimerecorddetailsByTimerecordtypeDto => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerFindOneById()` */
  static readonly TimerecorddetailsV2ControllerFindOneByIdPath = '/v2/timerecorddetails/{id}';

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetail>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetail>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:read, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetail> {
    return this.timerecorddetailsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetail>): WorkTimerecorddetail => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerDelete()` */
  static readonly TimerecorddetailsV2ControllerDeletePath = '/v2/timerecorddetails/{id}';

  /**
   * Required permissions: timerecorddetails:delete, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerDelete$Response(
    params: {
      id: number;
      body: WorkDeleteTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:delete, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerDelete(
    params: {
      id: number;
      body: WorkDeleteTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.timerecorddetailsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerUpdate()` */
  static readonly TimerecorddetailsV2ControllerUpdatePath = '/v2/timerecorddetails/{id}';

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetail>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetail>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTimerecorddetailDto
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetail> {
    return this.timerecorddetailsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetail>): WorkTimerecorddetail => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerReapplyPauseTemplate()` */
  static readonly TimerecorddetailsV2ControllerReapplyPauseTemplatePath = '/v2/timerecorddetails/reapplyPauseTemplate/byUserId/{userId}/{date}';

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerReapplyPauseTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerReapplyPauseTemplate$Response(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReapplyPauseTemplateResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerReapplyPauseTemplatePath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReapplyPauseTemplateResultDto>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerReapplyPauseTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerReapplyPauseTemplate(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkReapplyPauseTemplateResultDto> {
    return this.timerecorddetailsV2ControllerReapplyPauseTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReapplyPauseTemplateResultDto>): WorkReapplyPauseTemplateResultDto => r.body)
    );
  }

  /** Path part for operation `timerecorddetailsV2ControllerResetDay()` */
  static readonly TimerecorddetailsV2ControllerResetDayPath = '/v2/timerecorddetails/resetDay/byUserId/{userId}/{date}';

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV2ControllerResetDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerResetDay$Response(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReapplyPauseTemplateResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsV2Service.TimerecorddetailsV2ControllerResetDayPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReapplyPauseTemplateResultDto>;
      })
    );
  }

  /**
   * Required permissions: timerecorddetails:update, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV2ControllerResetDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecorddetailsV2ControllerResetDay(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkReapplyPauseTemplateResultDto> {
    return this.timerecorddetailsV2ControllerResetDay$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReapplyPauseTemplateResultDto>): WorkReapplyPauseTemplateResultDto => r.body)
    );
  }

}
